/**
 * Mesure des Web Vitals (Core Web Vitals + autres metriques UX).
 *
 * Role : recuperer les metriques de performance percues par l'utilisateur
 * (temps de chargement, reactivite, stabilite visuelle) et les envoyer a
 * un handler (typiquement Google Analytics, Sentry, ou un endpoint custom).
 *
 * Metriques collectees (via la lib `web-vitals` de Google) :
 * - CLS  (Cumulative Layout Shift)   : stabilite visuelle (< 0.1 = bon).
 * - FID  (First Input Delay)         : reactivite au premier clic (< 100ms = bon).
 * - FCP  (First Contentful Paint)    : premier contenu affiche (< 1.8s = bon).
 * - LCP  (Largest Contentful Paint)  : plus gros contenu affiche (< 2.5s = bon).
 * - TTFB (Time To First Byte)        : latence serveur (< 800ms = bon).
 *
 * Pourquoi `import()` dynamique (au lieu d'import statique en haut) :
 * lazy-load la lib `web-vitals` -- pas dans le bundle initial. Rendu utile
 * uniquement si un handler est passe (donc si le monitoring est active).
 *
 * Etat actuel : appele SANS handler dans `index.tsx` -> les mesures ne sont
 * pas envoyees. A brancher sur un endpoint quand le monitoring est en place
 * (Sprint 004+ ou plus tard).
 */

import { ReportHandler } from 'web-vitals';

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
